import { useContext } from 'react'
import { AppContext } from 'contexts/AppContext'
import Stack from '@careguide/stack'
import { ContentBlock } from '@careguide/theme'
import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'
import Logo from './Layout/Logo'
import { LoggedOutContent } from './LoggedOut'
import { LoggedInContent } from './LoggedIn'

export type HeaderProps = {
  viewer?: any
  loggedIn: boolean
  showUpgradeCta: boolean
}

export const Header = ({ viewer, loggedIn, showUpgradeCta }: HeaderProps) => {
  const { site } = useContext(AppContext)
  const userShouldSeeUpgradeCta = getUpgradeCtaVisibility(showUpgradeCta, viewer)

  return (
    <HeaderContainer>
      <Stack direction='horizontal' valign='center' gap='5'>
        <Logo
          altTag={site?.name}
          logoLarge={site?.fullLogoImageSource}
          logoSmall={site?.fullLogoMobileImageSource}
        />
        {loggedIn ? (
          <LoggedInContent viewer={viewer} showUpgradeCta={userShouldSeeUpgradeCta} />
        ) : (
          <LoggedOutContent site={site} showUpgradeCta={userShouldSeeUpgradeCta} />
        )}
      </Stack>
    </HeaderContainer>
  )
}

// TODO: move this logic cgc-app
const getUpgradeCtaVisibility = (showUpgradeCta: boolean, viewer: TODO) => {
  const isSubscribed = !!viewer.isSubscribed
  const hasListing = !!viewer.hasActiveListing
  const profileEligibleForUpgrade = !!viewer.profileEligibleForUpgrade
  return showUpgradeCta && profileEligibleForUpgrade && isSubscribed === false && hasListing
}

const HeaderContainer = styled(ContentBlock).attrs({
  // @ts-ignore TODO ContentBlock should support this
  as: 'nav',
  width: '100%',
  maxWidth: '1170px',
  paddingX: 4,
  valign: 'center',
  bg: 'white',
})`
  z-index: 1000;
  position: sticky;
  top: 0;
  left: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px -4px;
  ${css({
    height: ['48px', null, '82px'],
  })};
`
